import { defineStore } from 'pinia';
import { reactive } from 'vue';

interface PopoverColumnWidths {
  [key: string]: Record<string, number>;
}

export const usePopoverTableStore = defineStore('popoverTableStore', () => {
  const columnWidths = reactive<PopoverColumnWidths>({});

  const getColumnWidths = (key: string): Record<string, number> | undefined => {
    return columnWidths[key];
  };

  const setColumnWidths = (key: string, widths: Record<string, number>) => {
    columnWidths[key] = widths;
  };

  const setColumnWidth = (key: string, columnKey: string, width: number) => {
    if (!columnWidths[key]) {
      columnWidths[key] = {};
    }
    columnWidths[key][columnKey] = width;
  };

  return {
    columnWidths,
    getColumnWidths,
    setColumnWidths,
    setColumnWidth,
  };
}, {
  persist: {
    storage: localStorage,
    key: 'popoverTableStore',
    pick: ['columnWidths'],
  },
});
